import styled from 'styled-components';

export const Wrapper = styled.form`
  background: ${({ theme }) => theme.colors.lightPrimary};
  padding: ${({ theme }) => theme.spacings[6]};
  border-radius: ${({ theme }) => theme.borders.radiusLarge};
  width: 100%;
`;
